/*
 * Product gallery on mobile: dots under the photo instead of the arrow box
 * (the arrows are hidden in component-card-atc.css below 750px).
 * One dot per visible slide; tapping a dot scrolls to it; the active dot
 * follows the swipe. Works in RTL (scrollLeft is negative there).
 */
(() => {
  const mq = window.matchMedia('(max-width: 749px)');

  const build = (wrapper) => {
    const list = wrapper.querySelector('.product__media-list');
    if (!list || wrapper.querySelector('.o8-dots')) return;
    const slides = [...list.querySelectorAll('.product__media-item')].filter(
      (s) => getComputedStyle(s).display !== 'none'
    );
    if (slides.length < 2) return;

    const dots = document.createElement('div');
    dots.className = 'o8-dots';
    dots.setAttribute('role', 'tablist');
    slides.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'o8-dots__dot';
      dot.setAttribute('aria-label', `תמונה ${i + 1} מתוך ${slides.length}`);
      dot.addEventListener('click', () =>
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      );
      dots.appendChild(dot);
    });
    list.insertAdjacentElement('afterend', dots);

    const update = () => {
      const i = Math.round(Math.abs(list.scrollLeft) / Math.max(list.clientWidth, 1));
      dots.querySelectorAll('.o8-dots__dot').forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    list.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  };

  const init = () => {
    if (!mq.matches) return;
    document.querySelectorAll('.product__media-wrapper').forEach(build);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  mq.addEventListener?.('change', init);
})();
